'use strict';

// how many places are displayed by default,
// the rest items will be collapsed.

var defaultPlacesCount = 3;

var myPlacesIcons = {
  home: 'icon-home',
  work: 'icon-services',
  play: 'icon-marker'
};

module.exports = {
  fetching: false,
  error: null,
  items: [],
  collapse: true,
  fetched: false,

  getIcon: function getIcon(type) {
    return myPlacesIcons[type] || myPlacesIcons.home;
  },

  remove: function remove(id) {
    this.items = this.items.filter(function (place) {
      return place.id !== id;
    });
  },
  update: function update() {
    var _this = this;

    var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

    this.items = items.map(function (item) {
      return Object.assign(item, {
        icon: _this.getIcon(item.type) // get icon
      });
    });
  },
  needToBeCollapsed: function needToBeCollapsed() {
    return this.items.length > defaultPlacesCount && this.collapse;
  },
  fetchSuccess: function fetchSuccess(items) {
    this.update(items);
    this.fetching = false;
    this.fetched = true;
  },
  fetchError: function fetchError(err) {
    this.error = err;
    this.fetching = false;
  },
  showMore: function showMore() {
    this.collapse = false;
  },
  contains: function contains(address) {
    return this.items.some(function (item) {
      return item.address === address;
    });
  }
};